import React from 'react';
import { KeyboardArrowRight } from '@material-ui/icons';

import './css/ErrorPage.css';


class ErrorPage extends React.Component {
  render() {
    return (
      <div className="content error_page">
        <div className="container">
          <div className="container">
            <div className="row-r">
              <div className="col-xs-5">
                <h1 className="text-danger">
                  404
                </h1>
              </div>
              <div className="col-xs-7">
                <div className="error_message">
                  <h3>
                    Oops...
                  </h3>
                  <p className="lead">
                    We apologize, we were not able to find the page you were looking for. We may have missed something. Try visiting our archives page! Tons of Naked News there!
                  </p>
                  <p>
                    <a className="btn btn-lg btn-success error-page-archives-link" href="/archives">
                      Archives
                      <KeyboardArrowRight fontSize="large" />
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorPage;
